import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Clock } from "lucide-react";
import { CITIES, cityToSlug } from "../data/cities";

const PHONE = "01.84.16.20.60";
const PHONE_TEL = "tel:+33184162060";

export const Footer = () => (
  <footer className="bg-[#020617] text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-4">
        <div
          className="font-black text-2xl tracking-tight mb-1"
          style={{ fontFamily: "'Cabinet Grotesk','Manrope', sans-serif" }}
        >
          Débouchage <span className="text-[#FF5A1F]">Canalisation 93</span>
        </div>
        <p className="text-white/60 text-sm mb-5 leading-relaxed">
          L'expert n°1 du débouchage canalisation, dégorgement et curage haute
          pression en Seine-Saint-Denis. Urgences 24h/24 et 7j/7.
        </p>
        <a
          href={PHONE_TEL}
          className="inline-flex items-center gap-2 bg-[#FF5A1F] hover:bg-[#E04812] text-white font-extrabold px-5 py-3 rounded-full transition"
          data-testid="footer-call-btn"
        >
          <Phone className="w-4 h-4" /> {PHONE}
        </a>
      </div>

      <div className="lg:col-span-3">
        <div className="text-xs uppercase tracking-[0.25em] text-[#FF5A1F] font-bold mb-4">
          Services
        </div>
        <ul className="space-y-2 text-sm text-white/70">
          <li>Débouchage canalisation</li>
          <li>Débouchage WC & toilettes</li>
          <li>Dégorgement évacuation</li>
          <li>Curage haute pression</li>
          <li>Inspection caméra</li>
          <li>Entretien préventif</li>
        </ul>
      </div>

      <div className="lg:col-span-3">
        <div className="text-xs uppercase tracking-[0.25em] text-[#FF5A1F] font-bold mb-4">
          Villes desservies
        </div>
        <ul className="space-y-1.5 text-sm text-white/70 columns-2">
          {CITIES.slice(0, 16).map((c) => (
            <li key={c.name}>
              <Link
                to={`/debouchagecanalisation-${cityToSlug(c.name)}`}
                className="hover:text-[#FF5A1F]"
              >
                {c.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="lg:col-span-2">
        <div className="text-xs uppercase tracking-[0.25em] text-[#FF5A1F] font-bold mb-4">
          Contact
        </div>
        <ul className="space-y-3 text-sm text-white/70">
          <li className="flex gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#FF5A1F]" />26 Rue Victor Hugo, 93100 Montreuil</li>
          <li className="flex gap-2"><Phone className="w-4 h-4 mt-0.5 text-[#FF5A1F]" />{PHONE}</li>
          <li className="flex gap-2"><Clock className="w-4 h-4 mt-0.5 text-[#FF5A1F]" />24h/24 — 7j/7</li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
        <div>© {new Date().getFullYear()} Débouchage Canalisation 93 — Tous droits réservés.</div>
        <div>Mentions légales · CGV · Plan du site</div>
      </div>
    </div>
  </footer>
);

export default Footer;
